export default "__VITE_ASSET__lDZa4Ihi__"